import clsx from 'clsx';
import { forwardRef, type ReactNode } from 'react';

import { suffixWrapperCSS } from './TitleBar.sty.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';


//#region Typings
/**
 * Accepted properties for the TitleBar Suffix
 * @public
 */
export interface TitleBarSuffixProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Suffix slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Suffix component
 * @public
 */
export const Suffix = forwardRef<HTMLDivElement, TitleBarSuffixProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
    }: TitleBarSuffixProps = props;

    return (
      <div
        ref={forwardedRef}
        className={clsx(suffixWrapperCSS, consumerClassName)}
        style={consumerStyle}
        data-testid={dataTestId}
      >
        {children}
      </div>
    );
  },
);
